var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('resumen-dominio',{staticClass:"terminal-resumen",attrs:{"mensaje":"","response":_vm.response},on:{"addToList":_vm.addToList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }